Ext.define('SA.view.PointPackageDowngradedPopup', {
    alias: 'widget.point-package-downgraded-popup',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-point-package-downgraded-popup',
    includeOkBtn: true,

    getBodyItems() {
        var strong = text => `<strong>${text}</strong>`,
            commaList = Ext.util.Format.commaList,
            institution = SA.Institution.getName(),
            packages = this.notice.getPackageNames();

        return {
            xtype: 'component',
            cls: 'sa-point-package-downgraded-popup-message',

            html: [
                '<svg class="sa-point-package-downgraded-popup-message-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div class="sa-point-package-downgraded-popup-message-text">',
                    `${strong(institution)} no longer subscribes to the ${commaList(packages.map(strong), 'or', 'data package')}. `,
                    'As a result, you might notice that some businesses and some business fields are no longer available.',
                    '<br><br>',
                    'If you have any questions, please contact ',
                    '<a href="mailto:support@simplyanalytics.com">support@simplyanalytics.com</a>.',
                '</div>'
            ]
        };
    },

    getTitle() {
        var single = this.notice.getPackageNames().length === 1;

        return single ? 'Business Data Package Downgraded' : 'Business Data Packages Downgraded';
    },

    onDestroy() {
        this.notice.markViewed();

        this.callParent();
    }
});
